// extracted by mini-css-extract-plugin
export default {"customCheckbox":"customCheckbox___F9gXz"};